import { useTranslation } from 'react-i18next';
import { useEffect, useState } from 'react';
import apple from '../../assets/apple.svg';
import google from '../../assets/google.svg';
import './AppDownload.css';
import { getDeviceType } from '../../utils/deviceDetection';
import { openApp } from '../../utils/appDetection';

function AppDownload() {
    const { t } = useTranslation();
    const [deviceType, setDeviceType] = useState('desktop');

    useEffect(() => {
        setDeviceType(getDeviceType());
    }, []);

    const appIcon = (appType) => {
        return (
            <>
                <div className='app_store'>
                    <button
                        onClick={(e) => handleStoreClick(appType, e)}
                    >
                        <img src={appType === 'apple' ? apple : google} alt={appType === 'apple' ? "Google Play Store" : "Apple App Store"} />
                    </button>
                </div>
            </>
        )
    }
    const handleStoreClick = async (storeType, e) => {
        e.preventDefault();
        await openApp(storeType);
    };

    const renderStoreIcons = () => {
        switch (deviceType) {
            case 'android':
                return appIcon('google');
            case 'ios':
                return appIcon('apple');
            default:
                return (
                    <>
                        {appIcon('google')}
                        {appIcon('apple')}
                    </>
                );
        }
    };

    return (<>
        <div className='title'>
            {t('download_instruction')}
        </div>

        <div className='store_container'>
            {renderStoreIcons()}
        </div>
        <div className='instruction'>
            <div className='title'>
                {t('already_installed')}
            </div>
            <div className='content'>
                {t('scan_instruction')}
            </div>
        </div>
    </>)
}

export default AppDownload;